export const queryKeys = {
  tenant: {
    all: ['tenant'] as const,
    public: () => [...queryKeys.tenant.all, 'public'] as const,
  },
  publicAi: {
    status: (branchId: string) => ['publicAi', 'status', branchId] as const,
  },
  business: {
    all: ['business'] as const,
    overview: ['business', 'overview'] as const,
    orderMetrics: (date: string) => ['business', 'order-metrics', date] as const,
    intelligence: (startDate: string, endDate: string, branchId?: string) =>
      ['business', 'intelligence', startDate, endDate, branchId ?? null] as const,
    settings: ['business', 'settings'] as const,
    users: ['business', 'users'] as const,
    branches: ['business', 'branches'] as const,
    aiEscalations: (branchId = '', status = '') => ['business', 'ai-escalations', branchId, status] as const,
    waiters: ['business', 'waiters'] as const,
    tables: (branchId = '') => ['business', 'tables', branchId] as const,
    inventoryTemplates: ['business', 'inventory', 'templates'] as const,
    inventorySettings: ['business', 'inventory', 'settings'] as const,
    inventoryAssignments: ['business', 'inventory', 'assignments'] as const,
    inventoryBranch: (branchId = '') => ['business', 'inventory', 'branch', branchId] as const,
    inventoryMovements: (branchId = '', productId = '', limit = 20) => ['business', 'inventory', 'movements', branchId, productId, limit] as const,
    inventoryBranchMovements: (branchId = '', limit?: number) => limit === undefined
      ? ['business', 'inventory', 'branch-movements', branchId] as const
      : ['business', 'inventory', 'branch-movements', branchId, limit] as const,
    inventoryAlerts: (branchId = '', status = 'activa') => ['business', 'inventory', 'alerts', branchId, status] as const,
  },
  admin: {
    all: ['admin'] as const,
    overview: ['admin', 'overview'] as const,
    businesses: (search = '', status = '') => ['admin', 'businesses', search, status] as const,
    businessDetail: (businessId: string) => ['admin', 'businesses', 'detail', businessId] as const,
    businessLayout: (businessId: string) => ['admin', 'businesses', 'layout', businessId] as const,
    aiChatFailures: (status = 'active') => ['admin', 'ai-chat-failures', status] as const,
  },
  menu: {
    all: ['menu'] as const,
    catalog: ['menu', 'catalog'] as const,
    categories: ['menu', 'categories'] as const,
    products: ['menu', 'products'] as const,
    optionGroups: ['menu', 'option-groups'] as const,
    branches: ['menu', 'branches'] as const,
  },
  catalog: {
    all: ['catalog'] as const,
    public: (businessSlug: string, locationId?: string) => [
      'catalog',
      'public',
      businessSlug,
      locationId ?? null,
    ] as const,
  },
  orders: {
    all: ['orders'] as const,
    list: (branchId: string, status: string) =>
      ['orders', 'list', branchId, status] as const,
    detail: (orderId: string) => ['orders', 'detail', orderId] as const,
  },
  delivery: {
    order: (token: string) => ['delivery', 'order', token] as const,
  },
  kitchen: {
    zones: (branchId: string) =>
      ['kitchen', 'zones', branchId] as const,
  },
  waiter: {
    tables: (branchId = '') => ['waiter', 'tables', branchId] as const,
    account: (accountId: string) => ['waiter', 'account', accountId] as const,
  },
  publicOrders: {
    status: (token: string) =>
      ['publicOrders', 'status', token] as const,
  },
  availability: {
    all: ['availability'] as const,
    byDate: (locationId: string, serviceId: string, date: string) => [
      'availability',
      locationId,
      serviceId,
      date,
    ] as const,
  },
} as const;
